module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAgMAAABj6rKSAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURUdwTGZmZmRkZGZmZkqSt7IAAAADdFJOUwDfIMe4PcYAAAA3SURBVCjPY2CgDWBtQLDZExBszhsINlMZkoa5SBrU6avhAnY2shokvchmIttFW+XIYYgcttQGACC6FXm6Ydr8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/back-r.png
// module id = 5KwQ
// module chunks = 1